<se-modaldialog
    [header]="header"
    [closable]="false"
    [buttonOk]="buttonOk"
    [buttonCancel]="buttonCancel"
    [buttonYes]="buttonYes"
    [buttonNo]="buttonNo"
    [visible]="visible"
    [isWarning]="isWarning"
    [isError]="isError"
    (buttonClick)="onButtonClick($event)"
    (visibleChange)="onVisibileChange($event)"
    [windowSize]="windowSize"
>
    <ng-container content>
        {{ description }}

        <mat-list *ngIf="messageListData?.length" role="list">
            <mat-list-item *ngFor="let item of messageListData" role="listitem">
                {{ item }}
            </mat-list-item>
        </mat-list>
    </ng-container>
</se-modaldialog>
